export default __webpack_public_path__ + "static/media/link_out.082550dc.svg";